import facebook from "../components/img/facebook.svg"
import instagram from "../components/img/instagram.svg"
import linkedin from "../components/img/linkedin.svg"
import twitter from "../components/img/twitter.svg"
import male from "../components/img/m1.png"
import female from "../components/img/f1.png"

export const feedback = [
  {
    id: "feedback-1",
    content:
      "Torchbearers CCTV installation was seamless, and their professionalism was outstanding. I now have peace of mind knowing my property is well-protected",
    name: "James Otieno",
    title: "Customer",
    img: male,
  },
  {
    id: "feedback-2",
    content:
      "Torchbearers exceeded expectations with their solar PV installation. My home is now more energy-efficient, and I'm saving on utility costs. ",
    name: "Jane Wanjiku",
    title: "Customer",
    img: female,
  },
  {
    id: "feedback-3",
    content:
      "Torchbearers saved the day with quick and reliable electrical repairs. The technicians were knowledgeable and courteous, resolving my issues promptly.",
    name: "Musa Nasir",
    title: "Customer",
    img: male,
  },
];
export const socialMedia = [
  {
    id: "social-media-1",
    icon: instagram,
    link: "https://www.instagram.com/",
  },
  {
    id: "social-media-2",
    icon: facebook,
    link: "https://www.facebook.com/",
  },
  {
    id: "social-media-3",
    icon: twitter,
    link: "https://www.twitter.com/",
  },
  {
    id: "social-media-4",
    icon: linkedin,
    link: "https://www.linkedin.com/",
  },
];
export const footerLinks = [
  {
    title: "Useful Links",
    links: [
      {
        name: "Content",
        link: "https://www.hoobank.com/content/",
      },
      {
        name: "How it Works",
        link: "https://www.hoobank.com/how-it-works/",
      },
      {
        name: "Create",
        link: "https://www.hoobank.com/create/",
      },
      {
        name: "Explore",
        link: "https://www.hoobank.com/explore/",
      },
      {
        name: "Terms & Services",
        link: "https://www.hoobank.com/terms-and-services/",
      },
    ],
  },
  {
    title: "Community",
    links: [
      {
        name: "Help Center",
        link: "https://www.hoobank.com/help-center/",
      },
      {
        name: "Partners",
        link: "https://www.hoobank.com/partners/",
      },
      {
        name: "Suggestions",
        link: "https://www.hoobank.com/suggestions/",
      },
      {
        name: "Blog",
        link: "https://www.hoobank.com/blog/",
      },
      {
        name: "Newsletters",
        link: "https://www.hoobank.com/newsletters/",
      },
    ],
  },
  {
    title: "Partner",
    links: [
      {
        name: "Our Partner",
        link: "https://www.hoobank.com/our-partner/",
      },
      {
        name: "Become a Partner",
        link: "https://www.hoobank.com/become-a-partner/",
      },
    ],
  },
];
